// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2HsSC","author":"Table_author__1aW0X","authorImage":"Table_authorImage__2v_ow","unreadRow":"Table_unreadRow__3duO5"};